"use client";
import React, { useState, useEffect, useRef } from "react";
import Flickity from "react-flickity-component";
import "./home-slideshow.css";
import App from "../VideoModal/app";



const Slideshow = ({ banners, options }) => {
  const [carousel, setCarousel] = useState(null);
  const [openmodal , setModal] = useState(false);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window?.innerWidth : 0
  );
  const carouselRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(typeof window !== "undefined" ? window?.innerWidth : 0);
    };

    typeof window !== "undefined" &&
      window?.addEventListener("resize", handleResize);

    // Cleanup
    return () =>
      typeof window !== "undefined" &&
      window?.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (carousel) {
      // Initialize Flickity after component mounts
      carousel.flickity();
    }
  }, [carousel]);

  // Assume a mobile breakpoint at 768px
  const isMobile = windowWidth < 768;

  

  return (
    <div className="hero-carousel-container home-slider">
      <Flickity ref={carouselRef} options={options}>
        {banners.map((slide, index) => (
          <div key={index} className="carousel-cell">
            <img
              src={isMobile ? slide.mobileImageUrl : slide.imageUrl}
              alt={slide.title}
              className="carousel-image"
            />
            <div className="carousel-content">
              <h2 className="carousel-title">{slide.title}</h2>
              <p className="carousel-description">{slide.description}</p>
              <a style={{ fontWeight: "300" }}
                // href={slide.buttonLink}
                // target="_blank"
                className="btn carousel-button"
                onClick = {(e) => {e.preventDefault(); setModal(true);}}
                
              >
                {slide.buttonLabel}
              </a>
            </div>
          </div>
        ))}
      </Flickity>
      <App
        openModal={openmodal}
        setModal={setModal} />
    </div>
  );
};

export default Slideshow;
